import { useState, useEffect } from 'react';

function InstallPrompt() {
  const [prompt, setPrompt] = useState(null);
  const [show, setShow] = useState(false);
  const [isIos, setIsIos] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('pwa-dismissed')) return;

    const ios = /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.navigator.standalone;
    if (ios) { setIsIos(true); setShow(true); return; }

    const handler = e => { e.preventDefault(); setPrompt(e); setShow(true); };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  function dismiss() {
    localStorage.setItem('pwa-dismissed', '1');
    setShow(false);
    setDismissed(true);
    setShowModal(false);
  }

  async function install() {
    if (!prompt) return;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === 'accepted') setShow(false);
  }

  function handleBannerClick() {
    if (isIos) setShowModal(true);
    else install();
  }

  if (!show || dismissed) return null;

  return (
    <>
      <div className="install-banner" onClick={handleBannerClick}>
        <span className="install-banner-icon">🛒</span>
        <div className="install-banner-text">
          <strong>Add Cart Deals to your home screen</strong>
          <span>{isIos ? 'Tap here for instructions' : 'Install the app for quick access to deals'}</span>
        </div>
        <div className="install-banner-actions">
          {!isIos && <button className="install-btn-add" onClick={e => { e.stopPropagation(); install(); }}>Install</button>}
          <button className="install-btn-dismiss" onClick={e => { e.stopPropagation(); dismiss(); }}>✕</button>
        </div>
      </div>

      {showModal && (
        <div className="install-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="install-modal" onClick={e => e.stopPropagation()}>
            <h3 className="install-modal-title">Add to Home Screen</h3>
            <ol className="install-modal-steps">
              <li>
                <span className="install-step-icon">1</span>
                <span>Tap the <strong>Share</strong> button <span className="install-share-icon">⎋</span> at the bottom of Safari</span>
              </li>
              <li>
                <span className="install-step-icon">2</span>
                <span>Scroll down and tap <strong>"Add to Home Screen"</strong></span>
              </li>
              <li>
                <span className="install-step-icon">3</span>
                <span>Tap <strong>Add</strong> — Cart Deals appears on your home screen!</span>
              </li>
            </ol>
            <p className="install-modal-note">⚠️ Only works in <strong>Safari</strong>. If you're using Chrome, open this page in Safari first.</p>
            <div className="install-modal-actions">
              <button className="install-modal-got-it" onClick={() => setShowModal(false)}>Got it</button>
              <button className="install-modal-dismiss" onClick={dismiss}>Don't show again</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default InstallPrompt;
